import Button, { ButtonProps } from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { observer } from "mobx-react-lite";
import React, { ReactNode, useContext } from "react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { withOutLastPart } from "../../helpers/route";
import { makeStyles } from "@material-ui/styles";
import { routerContext, RouterStore } from "../../router/RouterStore";

export interface RelativeLinkProps extends RouteComponentProps<any> {
  router?: RouterStore;
  to: string;
  children: ReactNode;
}

const useStyles = makeStyles({
  link: {
    color: "inherit",
    textDecoration: "none"
  }
});

export const RelativeLink = withRouter(
  observer((props: RelativeLinkProps) => {
    const router = useContext(routerContext);
    const classes = useStyles();
    const pathName = router.location.pathname;
    const finalTo =
      props.to === "^" ? withOutLastPart(pathName) : pathName + props.to;
    return (
      <Link to={finalTo} className={classes.link}>
        {props.children}
      </Link>
    );
  })
);

export interface RelativeButtonLinkProps extends ButtonProps {
  to: string;
  icon?: any;
}

export const RelativeIconLink = ({
  icon,
  to,
  ...buttonProps
}: RelativeButtonLinkProps) => {
  let Type = React.forwardRef((props, ref) => (
    <RelativeLink to={to}>
      <IconButton {...props}>{icon}</IconButton>
    </RelativeLink>
  ));
  return <Type {...buttonProps} />;
};

export const RelativeButtonLink = ({
  to,
  children,
  icon,
  ...buttonProps
}: RelativeButtonLinkProps) => {
  children = children || "";
  return (
    <RelativeLink to={to}>
      <Button {...buttonProps}>
        {icon} {children}
      </Button>
    </RelativeLink>
  );
};
